import GearFilled from '../src/GearFilled';
export default GearFilled;
